// @ts-expect-error because it is injected by the browser
const extConf = ENVIRONMENT_SPECIFIC_CONFIG;

// @ts-expect-error because it is injected by the browser
const extBuildInfo = BUILD_INFORMATION;

const envSpecificConfig = {
  uiUrl: extConf.uiUrl,
  backendUrl: extConf.backendUrl,
  chordsheetjsProxyUrl:
    extConf.chordsheetjsProxyUrl || "http://localhost:50051",
  useProdSecurityInDevMode: !!(extConf.useProdSecurityInDevMode || false),
} as const;

const buildInformation = {
  dockerTag: extBuildInfo.dockerTag,
  gitRevision: extBuildInfo.gitRevision,
} as const;

export const UiConfig = {
  baseUrl: envSpecificConfig.uiUrl,
  appVersion: `${buildInformation.dockerTag}@${buildInformation.gitRevision}`,
} as const;

export const BackendConfig = {
  baseUrl: envSpecificConfig.backendUrl,
  chordsheetjsProxyUrl: envSpecificConfig.chordsheetjsProxyUrl,
} as const;

export const AuthConfig = {
  domain: "rebstokk.eu.auth0.com",
  clientId: "EUoLpk3gxPLBy8CCXP6tE9loL8VSVg2S", //Songship Single Page Application
  callbackUrl: envSpecificConfig.uiUrl + "/callback",
  audience: "https://backend.songship.app", //this does not change for beta because it identifies the API at Auth0
  useProdSecurityInDevMode: envSpecificConfig.useProdSecurityInDevMode,
} as const;

export const SongsheetsConfig = {
  url: envSpecificConfig.backendUrl,
} as const;
